import React from "react";
import Helmet from "react-helmet";

import faInstagram from "@fortawesome/fontawesome-free-brands/faInstagram";
import faTwitter from "@fortawesome/fontawesome-free-brands/faTwitter";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { OutboundLink } from 'gatsby-plugin-google-analytics';

import TalkyardCommentsIframe from '@debiki/gatsby-plugin-talkyard';

export default function BlogPost({
    data,
}) {
    const { markdownRemark: post } = data;
    return (
        <div>
            <Helmet title={`alexk - ${post.frontmatter.title}`} />
            <div>
                <h1>{post.frontmatter.title}</h1>
                <div dangerouslySetInnerHTML={{ __html: post.html }}/>
            </div>
            <hr/>
            <p style={{ marginBottom: '1rem', }}>Authored by Alex.</p>
            <span style={{ paddingRight: '1rem', }}><OutboundLink href='https://www.instagram.com/alexk.io/'><FontAwesomeIcon icon={faInstagram}/></OutboundLink></span>
            <span><OutboundLink href='https://twitter.com/alexk1o'><FontAwesomeIcon icon={faTwitter}/></OutboundLink></span>
            <TalkyardCommentsIframe discussionId={post.frontmatter.discussionId}/>
        </div>
    );
}

export const pageQuery = graphql`
    query BlogPostByPath($path: String!) {
        markdownRemark(frontmatter: { path: { eq: $path } }) {
            html
            frontmatter {
                date(formatString: "MMMM DD, YYYY")
                path
                title
                discussionId
            }
        }
    }
`;


// WEBPACK FOOTER //
// ./src/templates/blog-post.js